module.exports = __webpack_public_path__ + "static/media/icon-park_more-app.0c2e6289.svg";